import { Session } from "./common";

export class AuthSessionStorage {
  static setPrivateKey(uuid: string, privateKey: string): void {
    sessionStorage.setItem(uuid, privateKey);
  }

  static setRedirectUrl(uuid: string, redirect: string): void {
    sessionStorage.setItem(this.generateRedirectKey(uuid), redirect);
  }

  static getPrivateKey(uuid: string): string | null {
    return sessionStorage.getItem(uuid);
  }

  static getRedirectUrl(uuid: string): string | null {
    return sessionStorage.getItem(this.generateRedirectKey(uuid));
  }

  static setTimeStamp(session: Session): void {
    sessionStorage.setItem(session.token, new Date().getTime().toString());
  }

  static getTimeStamp(session: Session): number | null {
    const timeStamp = sessionStorage.getItem(session.token);

    if (timeStamp === null || Number.isNaN(Number(timeStamp))) {
      return null;
    }

    return Number(timeStamp);
  }

  private static generateRedirectKey(uuid: string): string {
    return `${uuid}#rel`;
  }
}
